import Link from '../../app/link';

interface PropTypes {
  url: string;
  text: string;
}

const StyledExternalLink = ({ text, url }: PropTypes) => (
  <Link href={url} target="_blank" rel="noreferrer">
    {text}
  </Link>
);

export default StyledExternalLink;
